"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getHouseFormulas = void 0;
var defs_1 = require("./defs");
var constants_1 = require("./constants");
var astro_utils_1 = require("./astro-utils");
var aspects_1 = require("./aspects");
function getSpecialAspects(object, objects, houses, astro) {
    var _a, _b, _c, _d;
    var aspects = [];
    var lon = objects[object].lon;
    var orbise = (_d = (_c = (_b = (_a = astro === null || astro === void 0 ? void 0 : astro.maps) === null || _a === void 0 ? void 0 : _a.natal) === null || _b === void 0 ? void 0 : _b.orbises[0][13]) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 4;
    for (var house = 0; house < houses.length; house++) {
        for (var _i = 0, _e = [defs_1.AspectType.Sextile, defs_1.AspectType.Square, defs_1.AspectType.Trine, defs_1.AspectType.Conjunction]; _i < _e.length; _i++) {
            var type = _e[_i];
            if ((0, aspects_1.checkAspect)(orbise, lon, houses[house], type).exists) {
                aspects.push({
                    type: type,
                    house: house
                });
            }
        }
    }
    return aspects;
}
function getHouseFormulas(data, astro) {
    var houseSign = {};
    for (var sign = 0; sign < 12; sign++) {
        houseSign[sign] = [];
    }
    data
        .houses
        .forEach(function (lon, i) { return houseSign[(0, astro_utils_1.getSign)(lon)].push(i); });
    var formulas = {};
    var planets = {};
    var houseFormulas = {};
    var specialFormulas = {};
    var addHouseFormula = function (p, h1, h2, suffix) {
        var pair = [h1, h2].sort(function (a, b) { return a - b; });
        var key = "".concat(pair[0] + 1, "#").concat(pair[1] + 1);
        houseFormulas[key] = __spreadArray(__spreadArray([], houseFormulas[key] || [], true), [{
                p: p,
                suffix: suffix
            }], false);
    };
    var _loop_1 = function (p) {
        var controls = [];
        var houses = (0, astro_utils_1.getObjectHouses)(data.objects[p].lon, data.houses, false);
        constants_1.controllers[p]
            .forEach(function (sign) {
            return houseSign[sign]
                .forEach(function (p) { return controls.push(p); });
        });
        planets[p] = {
            significators: constants_1.significators[p],
            houses: houses,
            controls: controls,
            specialAspects: getSpecialAspects(p, data.objects, data.houses, astro)
        };
        constants_1.significators[p].forEach(function (h1) { return houses.forEach(function (h2) { return addHouseFormula(p, h1, h2, 'S'); }); });
        controls.forEach(function (h1) { return houses.forEach(function (h2) { return addHouseFormula(p, h1, h2, 'A'); }); });
    };
    for (var p = defs_1.ObjectType.Sun; p <= defs_1.ObjectType.Pluto; p++) {
        _loop_1(p);
    }
    var aspectFormulas = {};
    data
        .aspects
        .forEach(function (asp) {
        var obj1 = planets[asp.obj1];
        var obj2 = planets[asp.obj2];
        if (!obj1 || !obj2 || !constants_1.majorAspects.includes(asp.type)) {
            return;
        }
        var allHouses1 = new Set(__spreadArray(__spreadArray(__spreadArray([], obj1.houses, true), obj1.controls, true), obj1.significators, true));
        var allHouses2 = new Set(__spreadArray(__spreadArray(__spreadArray([], obj2.houses, true), obj2.controls, true), obj2.significators, true));
        allHouses1
            .forEach(function (h1) {
            return allHouses2
                .forEach(function (h2) {
                var toks = [
                    {
                        h: h1,
                        o: asp.obj1
                    },
                    {
                        h: h2,
                        o: asp.obj2
                    }
                ].sort(function (a, b) { return a.h - b.h; });
                var key = "".concat(toks[0].h + 1, "#").concat(toks[1].h + 1);
                aspectFormulas[key] = __spreadArray(__spreadArray([], aspectFormulas[key] || [], true), [
                    {
                        obj1: toks[0].o,
                        obj2: toks[1].o,
                        type: asp.type
                    }
                ], false);
            });
        });
    });
    var addSpecialFormulas = function (suffix, planet, aspect, houses) {
        houses
            .forEach(function (house) {
            var toks = [house, aspect.house].sort(function (a, b) { return a - b; });
            var key = "".concat(toks[0] + 1, "#").concat(toks[1] + 1);
            specialFormulas[key] = __spreadArray(__spreadArray([], specialFormulas[key] || [], true), [
                {
                    planet: planet,
                    suffix: suffix,
                    aspType: aspect.type,
                    aspHouse: aspect.house,
                    house: house
                }
            ], false);
        });
    };
    Object
        .entries(planets)
        .forEach(function (_a) {
        var k = _a[0], v = _a[1];
        var p = +k;
        v
            .specialAspects
            .forEach(function (a) {
            addSpecialFormulas('A', p, a, v.controls);
            addSpecialFormulas('S', p, a, v.significators);
            addSpecialFormulas('', p, a, v.houses);
        });
    });
    var filteredData = function (_specialFormulas) {
        var result = {};
        for (var key in _specialFormulas) {
            if (Array.isArray(_specialFormulas[key])) {
                result[key] = Object.values(_specialFormulas[key].reduce(function (acc, item) {
                    var key = "".concat(item.planet, "-").concat(item.house, "-").concat(item.aspType);
                    if (!acc[key]) {
                        acc[key] = item;
                    }
                    else {
                        if (item.suffix === 'S') {
                            acc[key] = item;
                        }
                        else if (item.suffix === 'A' && acc[key].suffix !== 'S') {
                            acc[key] = item;
                        }
                        else if (item.suffix === '' && acc[key].suffix !== 'S' && acc[key].suffix !== 'A') {
                            acc[key] = item;
                        }
                    }
                    return acc;
                }, {}));
            }
        }
        specialFormulas = result;
    };
    var addFormulas = function (data) {
        for (var key in data) {
            formulas[key] = (formulas[key] || 0) + data[key].length;
        }
    };
    filteredData(specialFormulas);
    addFormulas(aspectFormulas);
    addFormulas(houseFormulas);
    addFormulas(specialFormulas);
    return {
        planets: planets,
        aspectFormulas: aspectFormulas,
        houseFormulas: houseFormulas,
        specialFormulas: specialFormulas,
        formulas: formulas
    };
}
exports.getHouseFormulas = getHouseFormulas;
